import { DatePicker, Form } from 'antd';
import { DropdownIcon } from 'assets/Icons/AppointmentIcons';
import Calendar from 'assets/Icons/calendar';
import styled from 'styled-components';

const BookingV4DateSection = () => {
  return (
    <Wrapper>
      <span className="calendar-icon">
        <Calendar />
      </span>
      <Form.Item noStyle name="date">
        <StyledDatePicker
          allowClear={false}
          inputReadOnly
          format="MMM DD, YYYY"
          suffixIcon={<DropdownIcon />}
        />
      </Form.Item>
    </Wrapper>
  );
};

export default BookingV4DateSection;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: #fff;
  border-radius: 8px;

  .calendar-icon {
    position: absolute;
    left: 32px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    pointer-events: none;
    z-index: 1;
    svg path {
      fill: #d2464f;
    }
  }
`;

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  height: 56px;
  padding: 16px 16px 16px 48px;
  border: 1px solid #adadad;
  border-radius: 4px;

  .ant-picker-input > input {
    font-family: Poppins;
    font-size: 20px;
    font-weight: 600;
    color: #1d2129;
  }
  .ant-picker-suffix {
    color: #1d2129;
    font-size: 24px;
  }
`;
